// Entitlement gate for LLM-authored custom widgets (render_widget). PLEX-4237.
//
// Reads the EntitlementsStore catalog path (NOT the PostHog flag in
// lib/entitlements.js). Default OFF: isFeatureEnabled returns false until
// loadMine() resolves a grant, so widgets stay hidden pre-load (no
// flash-of-widget). Called inside observer renders — isFeatureEnabled reads
// MobX observables, so callers re-render when the grant resolves.

// Mirrors KNOWN_FEATURES["custom-widgets"] in rd's entitlements/validation.py
// and the CATALOG entry in EntitlementsStore.js.
export const CUSTOM_WIDGETS_FEATURE = "custom-widgets";

/** True when the current user is entitled to custom widgets. */
export function customWidgetsEnabled() {
  // Required lazily, not imported at module scope: LLMClient imports this file, and
  // stores/index constructs SearchSessionStore -> ... -> SafeRenderer -> LLMClient, so a
  // top-level import closed that loop and left SearchSessionStore undefined at the point
  // stores/index tried to `new` it. Only ever called from an observer render, well after
  // module evaluation, so MobX reactivity is unaffected.
  const { rootStore } = require("../stores");
  return !!rootStore?.entitlementsStore?.isFeatureEnabled?.(CUSTOM_WIDGETS_FEATURE);
}
